<div>
	<router-view :read-only="readOnly" :submitted="submitted"/>
</div>